export default "__VITE_ASSET__BQNGfsEw__"